import React from "react";

import MuiTable from "@mui/material/Table";
import TableRow from "@mui/material/TableRow";
import TableCell from "@mui/material/TableCell";
import TableBody from "@mui/material/TableBody";
import TableContainer from "@mui/material/TableContainer";
import Skeleton from "@mui/material/Skeleton";

import TableHead from "../TableHead";

import { DataTableColumn } from "../../types";

interface TableSkeletonProps<T> {
  columns: DataTableColumn<T>[];
  rowCount?: number;
  withActions?: boolean;
}

const TableSkeleton = <T extends { id: string }>(
  props: TableSkeletonProps<T>,
) => {
  const { columns, rowCount = 5, withActions } = props;

  return (
    <>
      <TableContainer sx={{ mt: -1 }}>
        <MuiTable>
          <TableHead<T> columns={columns} withActions={withActions} />
          <TableBody>
            {Array.from({ length: rowCount }).map((_, rowIndex) => (
              <TableRow key={`skeleton-row-${rowIndex}`}>
                {columns.map(({ field, width }, colIndex) => (
                  <TableCell
                    sx={{ width }}
                    key={`skeleton-cell-${field}-${colIndex}`}
                  >
                    <Skeleton animation="wave" />
                  </TableCell>
                ))}
                {withActions && (
                  <TableCell sx={{ width: "5%" }} align="right">
                    <Skeleton animation="wave" />
                  </TableCell>
                )}
              </TableRow>
            ))}
          </TableBody>
        </MuiTable>
      </TableContainer>
    </>
  );
};

export default TableSkeleton;
